import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import {
  Button,
  Chip,
  ClickAwayListener,
  Tooltip,
  tooltipClasses,
  useMediaQuery,
} from "@mui/material";
import * as Yup from "yup";
import toast from "react-hot-toast";

import { clearFormValues, RestfullApiService } from "../../config/service";
import badge from "../../assets/img/icons/badge.png";
import DefaultEventImg from "../../assets/img/masthead/default-event.png";
import { decryptData } from "../../utils/storage";
import { MEDIA_URL, RAZORPAY_KEY } from "../../config/url";
import Swal from "sweetalert2";
import { useTheme } from "@emotion/react";
import { useSelector } from "react-redux";
import { LoadingButton } from "@mui/lab";
import { removeSpace } from "../../utils";

function PaymentDetails(props) {
  const navigate = useNavigate();
  const [event, setEvent] = useState();
  const [paymentDetails, setPaymentDetails] = useState();
  const [registeredUsers, setRegisteredUsers] = useState([]);
  const [discountApplied, setDiscountApplied] = useState(false);
  const [paying, setPaying] = useState(false);
  const [viewMore, setViewMore] = useState(false);
  const [openCoupon, setOpenCoupon] = useState(false);
  const [gstAvail, setGstAvail] = useState(false);
  const [submittingGst, setSubmittingGst] = useState(false);
  const [isGstFormSubmitted, setIsGstFormSubmitted] = useState(false);
  const [toggleCoupon, setToggleCoupon] = useState(false);
  const [applyingCoupon, setApplyingCoupon] = useState(false);
  const [validCoupon, setValidCoupon] = useState();
  const [open, setOpen] = React.useState(false);
  const { editing, setEditing, setActiveTab } = props;
  const user = useSelector((state) => state.user.userProfile);
  const eventDisplay = JSON.parse(
    localStorage.getItem("registeredParticipants")
  )[0];

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  function loadScript(src) {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  }

  async function paymentFailed(payload, eventDetails, paymentObject) {
    const reason = payload?.error?.reason ?? "";

    const data = {
      Method_Name: payload?.error?.source ?? "",
      Org_Id: user?.Org_Id,
      Session_User_Id: user?.Participant_Id,
      Session_User_Name: user?.First_Name + " " + user?.Last_Name,
      Booking_Id: localStorage.getItem("Booking_Id"),
      Status: reason,
    };
    try {
      setPaying(true);
      const result = await RestfullApiService(data, "participant/paymentfail");
      console.log("Payment failed data logged:", result?.data);
    } catch (err) {
      console.error("Error logging payment failure:", err);
      toast.error("Server Error");
    } finally {
      // Close the Razorpay modal
      if (paymentObject?.close) {
        paymentObject.close();
        console.log("Razorpay modal closed after payment failure.");
      }
      setPaying(false);
    }
  }

  async function displayRazorpay(eventDetails) {
    const Booking_Id = localStorage.getItem("Booking_Id");
    const Event_Id = decryptData(localStorage.getItem("eventId"));
    const paymentDetails = JSON.parse(localStorage.getItem("paymentDetails"));

    if (
      paymentDetails?.Total_Amount_With_Gst === 0 &&
      paymentDetails?.After_Discount_Amount === 0
    ) {
      const data = {
        Method_Name: "Confirm_Order",
        Org_Id: user?.Org_Id,
        Session_User_Id: user?.Participant_Id,
        Session_User_Name: user?.First_Name + " " + user?.Last_Name,
        Booking_Id: Booking_Id,
        razorpay_payment_id: "",
        Status: "Success",
        razorpay_order_id: "",
        razorpay_signature: "",
      };
      try {
        setPaying(true);
        const result = await RestfullApiService(
          data,
          "participant/order_confirm"
        );
        console.log(result?.data);
        if (result) {
          console.log(result?.data);
          localStorage.setItem(
            "Order_Details",
            JSON.stringify(result?.data?.Result?.Table2)
          );
          localStorage.setItem("Event_ID", JSON.stringify(Event_Id));
          navigate("/ticket-details", { replace: true });
          // window.location.replace("/ticket-details");
          clearFormValues();
        } else {
          alert("Server error. Are you online?");
          return;
        }
      } catch (err) {
        console.log(err);
        toast.error("Server Error");
      } finally {
        setPaying(false);
      }
      return;
    }

    setPaying(true);
    const res = await loadScript(
      "https://checkout.razorpay.com/v1/checkout.js"
    );

    if (!res) {
      alert("Razorpay SDK failed to load. Are you online?");
      return;
    }
    const reqdata = {
      Method_Name: "Booking",
      Org_Id: user?.Org_Id,
      Session_User_Id: user?.Participant_Id,
      Session_User_Name: user?.First_Name + " " + user?.Last_Name,
      Booking_Id: Booking_Id,
    };
    const result = await RestfullApiService(
      reqdata,
      "participant/create_order"
    );

    if (!result) {
      alert("Server error. Are you online?");
      return;
    }

    console.log(result.data);
    console.log(JSON.parse(result.data.Description));
    const { id, amount, currency } = JSON.parse(result.data.Description);
    const { Total_Amount_With_Gst, Booking_Id: order_id } =
      result?.data?.Result?.Table1[0];
    console.log(Total_Amount_With_Gst, order_id, currency);

    const options = {
      key: RAZORPAY_KEY, // Enter the Key ID generated from the Dashboard
      // amount: Total_Amount_With_Gst.toString(),
      amount: amount,
      currency: currency,
      name: "Fitizen",
      description: "Test Transaction",
      image: "https://admin.fitizenindia.com/favicon.png",
      order_id: id,
      handler: async function (response) {
        const data = {
          Method_Name: "Confirm_Order",
          Org_Id: user?.Org_Id,
          Session_User_Id: user?.Participant_Id,
          Session_User_Name: user?.First_Name + " " + user?.Last_Name,
          Booking_Id: order_id,
          razorpay_payment_id: response.razorpay_payment_id,
          Status: "Success",
          razorpay_order_id: response.razorpay_order_id,
          razorpay_signature: response.razorpay_signature,
        };
        try {
          const result = await RestfullApiService(
            data,
            "participant/order_confirm"
          );
          console.log(result?.data);
          if (result) {
            console.log(result?.data);
            localStorage.setItem(
              "Order_Details",
              JSON.stringify(result?.data?.Result?.Table2)
            );
            localStorage.setItem(
              "Date_Time",
              JSON.stringify(result?.data?.Result?.Table3)
            );
            localStorage.setItem("Event_Data", JSON.stringify(eventDisplay));
            localStorage.setItem("Event_ID", JSON.stringify(Event_Id));
            navigate("/ticket-details", { replace: true });
            clearFormValues();
          } else {
            alert("Server error. Are you online?");
            return;
          }
        } catch (err) {
          console.log(err);
          toast.error("Server Error");
        }
      },
      // prefill: {
      //   name: "Omkar",
      //   email: "omkar@example.com",
      //   contact: "9999999999",
      // },
      notes: {
        address: "Fitizen",
      },
      theme: {
        color: "#61dafb",
      },
      modal: {
        ondismiss: () => {
          console.log("Error");
        },
      },
    };

    const paymentObject = new window.Razorpay(options);

    paymentObject.on("payment.failed", async function (response) {
      console.log(response);
      alert(response.error.description);
      await paymentFailed(response ?? {}, eventDetails, paymentObject);

      // paymentFailed();
      // Handle payment failure here
    });

    paymentObject.open();
    setPaying(false);
  }
  const validationSchema = Yup.object().shape({
    promoCode: Yup.string().required("Promo code is required"),
  });
  const gstvalidationSchema = Yup.object().shape({
    Company_Name: Yup.string().required("Company Name is required"),
    Company_Gst: Yup.string()
      .matches(
        /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
        "Invalid GST Number"
      )
      .required("GST Number is required"),
  });
  const initialValues = {
    Company_Name: "",
    Company_Gst: "",
  };
  const handleToggleCoupon = () => {
    setToggleCoupon(!toggleCoupon);
  };
  const removeCouponCode = async (resetForm) => {
    const Booking_Id = localStorage.getItem("Booking_Id");
    const Event_Id = decryptData(localStorage.getItem("eventId"));
    // const user = JSON.parse(localStorage.getItem("userProf"));

    const reqdata = {
      Method_Name: "Remove",
      Org_Id: user?.Org_Id,
      Session_User_Id: user?.Participant_Id,
      Session_User_Name: user?.First_Name + " " + user?.Last_Name,
      Event_Id: Event_Id,
      Total_Amount: "0.0",
      Coupon_Code: "",
      Booking_Id: Booking_Id,
    };
    toast.promise(RestfullApiService(reqdata, "participant/discount"), {
      loading: "Removing Coupon...",
      success: (result) => {
        if (result) {
          localStorage.setItem(
            "paymentDetails",
            JSON.stringify(result?.data?.Result?.Table1[0])
          );
          setDiscountApplied(false);
          setValidCoupon(null);
          setPaymentDetails(result?.data?.Result?.Table1[0]);
        }
        return `Coupon Code ${validCoupon?.promoCode} Removed`;
      },
      error: (err) => {
        const errorMessage =
          err?.Result?.Table1[0]?.Result_Description || "Failed";
        return errorMessage;
      },
    });
    // try {
    // const result = await RestfullApiService(reqdata, "participant/discount");
    // if (result) {
    //   console.log(result?.data);
    //   localStorage.setItem(
    //     "paymentDetails",
    //     JSON.stringify(result?.data?.Result?.Table1[0])
    //   );
    //   setDiscountApplied(false);
    //   toast.error(`Coupon Code ${validCoupon?.promoCode} Removed`);
    //   setValidCoupon(null);
    // setFieldValue("promoCode", "");
    // resetForm();
    //   setPaymentDetails(result?.data?.Result?.Table1[0]);
    // }
    // } catch (err) {
    // toast.error(err?.Result?.Table1[0]?.Result_Description);
    // }
  };
  const applyCouponCode = async (coupon) => {
    const Booking_Id = localStorage.getItem("Booking_Id");
    const Event_Id = decryptData(localStorage.getItem("eventId"));
    const paymentDetails = JSON.parse(localStorage.getItem("paymentDetails"));
    // const user = JSON.parse(localStorage.getItem("userProf"));

    const reqdata = {
      Method_Name: "Apply",
      Org_Id: user?.Org_Id,
      Session_User_Id: user?.Participant_Id,
      Session_User_Name: user?.First_Name + " " + user?.Last_Name,
      Event_Id: Event_Id,
      Total_Amount: paymentDetails?.Total_Amount_With_Gst,
      Coupon_Code: coupon?.promoCode,
      Booking_Id: Booking_Id,
    };
    try {
      setApplyingCoupon(true);
      const result = await RestfullApiService(reqdata, "participant/discount");
      if (result) {
        console.log(result?.data);
        if (result?.data?.Result?.Table1[0]?.Result_Id === -1) {
          setDiscountApplied(false);
          setValidCoupon(null);
          toast.error(result?.data?.Result?.Table1[0]?.Result_Description);
          return;
        }
        localStorage.setItem(
          "paymentDetails",
          JSON.stringify(result?.data?.Result?.Table1[0])
        );
        setDiscountApplied(true);
        setValidCoupon(coupon);
        setPaymentDetails(result?.data?.Result?.Table1[0]);
        toast.success(`Coupon Code ${coupon?.promoCode} Applied`);
      }
    } catch (err) {
      setValidCoupon(null);
      setDiscountApplied(false);
      toast.error(err?.Result?.Table1[0]?.Result_Description);
    } finally {
      setApplyingCoupon(false);
    }
  };
  const applyGst = async (values) => {
    const Booking_Id = localStorage.getItem("Booking_Id");

    const reqdata = {
      IsGst_Available: 1,
      Booking_Id: Booking_Id,
      Company_Name: values?.Company_Name,
      Company_Gst: values?.Company_Gst,
    };
    console.log(reqdata);

    try {
      setSubmittingGst(true);
      const result = await RestfullApiService(reqdata, "participant/updategst");
      if (result) {
        console.log(result?.data);
        if (result?.data?.Result?.Table1[0]?.Result_Id === -1) {
          toast.error(result?.data?.Result?.Table1[0]?.Result_Description);
          setIsGstFormSubmitted(false);
          return;
        }

        setIsGstFormSubmitted(true);
        toast.success(result?.data?.Result?.Table1[0]?.Result_Description);
      }
    } catch (err) {
      toast.error(err?.Result?.Table1[0]?.Result_Description);
    } finally {
      setSubmittingGst(false);
    }
  };
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  useEffect(() => {
    const eventId = localStorage.getItem("eventId");
    const paymentDetails = JSON.parse(localStorage.getItem("paymentDetails"));
    const registeredParticipants = JSON.parse(
      localStorage.getItem("registeredParticipants")
    );

    setEvent(eventId);

    // if (discountDetails) {
    //   setPaymentDetails(discountDetails);
    // } else {
    setPaymentDetails(paymentDetails);
    setRegisteredUsers(registeredParticipants);
    // }
  }, []);

  const EventId = localStorage.getItem("eventId");

  return (
    <>
      <section
        style={{ marginTop: "80px" }}
        className="py-5 d-flex items-center bg-blue-1-05"
      >
        <div className="container">
          <div className="row y-gap-10 items-center justify-between font-inter">
            <div className="col-auto">
              <div className="row x-gap-10 y-gap-5 items-center text-14 fw-500 text-light-1">
                <div className="col-auto">
                  <div
                    className="cursor-pointer"
                    onClick={async () => {
                      const shouldDelete = await Swal.fire({
                        title:
                          "Are you sure you want to go back? Your changes will be lost.",
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#f05736",
                        cancelButtonColor: "#3085d6",
                        confirmButtonText: "Yes",
                      });

                      if (shouldDelete.isConfirmed) {
                        try {
                          clearFormValues();
                          navigate("/", { replace: true });
                        } catch (err) {
                          console.error("API Error:", err);
                          toast.error("Failed to navigate back");
                        }
                      }
                    }}
                  >
                    Home
                  </div>
                </div>
                <div className="col-auto">
                  <div className="">{">"}</div>
                </div>
                <div className="col-auto">
                  <div
                    className="cursor-pointer"
                    onClick={async () => {
                      const shouldDelete = await Swal.fire({
                        title:
                          "Are you sure you want to go back? Your changes will be lost.",
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#f05736",
                        cancelButtonColor: "#3085d6",
                        confirmButtonText: "Yes",
                      });

                      if (shouldDelete.isConfirmed) {
                        try {
                          clearFormValues();
                          navigate("/event/list", { replace: true });
                        } catch (err) {
                          console.error("API Error:", err);
                          toast.error("Failed to navigate back");
                        }
                      }
                    }}
                  >
                    Events
                  </div>
                </div>
                <div className="col-auto">
                  <div className="">{">"}</div>
                </div>
                <div className="col-auto">
                  <div
                    className="cursor-pointer"
                    onClick={async () => {
                      const shouldDelete = await Swal.fire({
                        title:
                          "Are you sure you want to go back? Your changes will be lost.",
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#f05736",
                        cancelButtonColor: "#3085d6",
                        confirmButtonText: "Yes",
                      });

                      if (shouldDelete.isConfirmed) {
                        try {
                          clearFormValues();
                          navigate(
                            `/event-details/${removeSpace(
                              eventDisplay?.Display_Name
                            )}/${EventId}`,
                            {
                              replace: true,
                            }
                          );
                        } catch (err) {
                          console.error("API Error:", err);
                          toast.error("Failed to navigate back");
                        }
                      }
                    }}
                  >
                    Events Details
                  </div>
                </div>
                <div className="col-auto">
                  <div className="">{">"}</div>
                </div>
                <div className="col-auto">
                  <div
                    className="cursor-pointer"
                    onClick={async () => {
                      const shouldDelete = await Swal.fire({
                        title:
                          "Are you sure you want to go back? Your changes will be lost.",
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#f05736",
                        cancelButtonColor: "#3085d6",
                        confirmButtonText: "Yes",
                      });

                      if (shouldDelete.isConfirmed) {
                        try {
                          clearFormValues();
                          navigate(`/event-category/${EventId}`, {
                            replace: true,
                          });
                        } catch (err) {
                          console.error("API Error:", err);
                          toast.error("Failed to navigate back");
                        }
                      }
                    }}
                  >
                    Event Category
                  </div>
                </div>
                <div className="col-auto">
                  <div className="">{">"}</div>
                </div>
                <div className="col-auto">
                  <div className="text-primary">Fill Up Form</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="layout-pt-sm layout-pb-md">
        <div className="container">
          <div className="shadow-2 rounded-16 px-40 py-40 lg:px-15 lg:py-20">
            <div className="border-bottom-type-1">
              <div className="row">
                <div className="col-8">
                  <h4 className="text-primary fw-600 text-18 lg:text-16 mb-30">
                    {registeredUsers[0]?.Display_Name}
                  </h4>
                </div>
                <div className="col-4 text-right">
                  <button
                    onClick={() => {
                      sessionStorage.setItem("editing", true);
                      setEditing(true);
                      setActiveTab(1);
                    }}
                    className="button rounded-22 bg-primary px-20 py-5 text-white -dark-1 w-100"
                    style={{ float: "right" }}
                  >
                    Edit
                  </button>
                </div>
              </div>
              <div className="row mb-10 mt-30 font-inter">
                <div className="col-lg-2 col-md-6 lg:text-center">
                  <div className="overflow-hidden mb-20">
                    <img
                      src={
                        registeredUsers[0]?.Image_Path
                          ? `${MEDIA_URL}${registeredUsers[0]?.Image_Path}`
                          : DefaultEventImg
                      }
                      className="rounded-full object-cover border-primary"
                      style={{ width: "110px", height: "110px" }}
                      alt="event"
                    />
                  </div>
                </div>
                <div className="col-lg-8 col-md-6">
                  {registeredUsers?.slice(0, 3)?.map((user, index) => {
                    return (
                      <>
                        <div className={`row${index !== 0 ? " pt-25" : ""}`}>
                          <div className="col-lg-4 col-md-6 border-right-secondary lg:border-none lg:d-flex lg:items-center lg:mt-10">
                            <div className="text-14 text-primary lh-12 lg:w-100">
                              Name
                            </div>
                            <div className="text-13 lh-12 fw-600 mt-20 lg:mt-0 lg:ml-10 word-break">
                              {user?.First_Name ?? ""} {user?.Last_Name ?? ""}
                            </div>
                          </div>
                          <div className="col-lg-4 col-md-6 border-right-secondary lg:border-none lg:d-flex lg:items-center lg:mt-10">
                            <div className="text-14 text-primary lh-12 lg:w-100">
                              Event Type
                            </div>
                            <div className="text-13 lh-12 fw-600 mt-20 lg:mt-0 lg:ml-10 word-break">
                              {user?.EventType_Name}
                            </div>
                          </div>
                          <div className="col-lg-4 col-md-6 lg:d-flex lg:items-center lg:mt-10">
                            <div className="text-14 text-primary lh-12 lg:w-100">
                              Race Distance
                            </div>
                            <div className="text-13 lh-12 fw-600 mt-20 lg:mt-0 lg:ml-10 word-break">
                              {user?.EventCategory_Name}
                            </div>
                          </div>
                        </div>
                        <div
                          key={index}
                          // className={`row pb-20 ${
                          //   index === registeredUsers?.length - 1
                          //     ? ""
                          //     : "border-bottom-light"
                          // } `}
                          className={`row pb-25 border-bottom-dotted`}
                        ></div>
                      </>
                    );
                  })}
                </div>
                <div className="col-lg-2"></div>
                {viewMore && <div className="col-lg-2"></div>}
                {viewMore && (
                  <div className="col-lg-8 col-md-6">
                    {registeredUsers?.slice(3)?.map((user, index) => {
                      return (
                        <>
                          {/* <div className={`row${index !== 3 ? " pt-25" : ""}`}> */}
                          <div className={`row pt-25`}>
                            <div className="col-lg-4 col-md-6 border-right-secondary lg:border-none lg:d-flex lg:items-center">
                              <div className="text-14 text-primary lh-12">
                                Name
                              </div>
                              <div className="text-13 lh-12 fw-600 mt-20 lg:mt-0 lg:ml-10">
                                {user?.First_Name ?? ""} {user?.Last_Name ?? ""}
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-6 border-right-secondary lg:border-none lg:d-flex lg:items-center">
                              <div className="text-14 text-primary lh-12">
                                Event Type
                              </div>
                              <div
                                className="text-13 lh-12 fw-600 mt-20 lg:mt-0 lg:ml-10"
                                style={{ marginLeft: "-18px" }}
                              >
                                {user?.EventType_Name}
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-6 lg:d-flex lg:items-center">
                              <div className="text-14 text-primary lh-12">
                                Race Distance
                              </div>
                              <div
                                className="text-13 lh-12 fw-600 mt-20 lg:mt-0 lg:ml-10"
                                style={{ marginLeft: "-4px" }}
                              >
                                {user?.EventCategory_Name}
                              </div>
                            </div>
                          </div>
                          <div
                            key={index}
                            // className={`row pb-20 ${
                            //   index === registeredUsers?.length - 1
                            //     ? ""
                            //     : "border-bottom-light"
                            // } `}
                            className={`row pb-25 border-bottom-dotted`}
                          ></div>
                        </>
                      );
                    })}
                  </div>
                )}
                {viewMore && <div className="col-lg-2"></div>}
                <div className="col-lg-2"></div>
                {registeredUsers?.length > 3 && (
                  <div className="col-lg-8 d-flex justify-end my-3">
                    {!viewMore ? (
                      <p
                        className="text-primary text-13 cursor-pointer"
                        onClick={() => {
                          setViewMore(true);
                        }}
                      >
                        ...View More
                      </p>
                    ) : (
                      <p
                        className="text-primary text-13 cursor-pointer"
                        onClick={() => {
                          setViewMore(false);
                        }}
                      >
                        ...View Less
                      </p>
                    )}
                  </div>
                )}
              </div>
            </div>
            <div className="row pt-20 font-inter">
              <div className="col-lg-6 border-right lg:border-none">
                <div className="accordion -simple row y-gap-20 js-accordion font-inter">
                  <div
                    className="col-12 pb-0"
                    style={{ paddingBottom: "0px !important" }}
                  >
                    <div
                      className={`accordion__item is-active`}
                      style={{ padding: "22px 0" }}
                    >
                      <div className="accordion__button d-flex items-center justify-between">
                        <div className="button text-14 fw-600">
                          Apply Coupon Code
                        </div>
                        <img src={badge} alt="badge" width="20" />
                      </div>

                      <div className={`accordion__content accordion__max_h`}>
                        <Formik
                          enableReinitialize
                          initialValues={{ promoCode: "" }}
                          validationSchema={Yup.object().shape({
                            promoCode: Yup.string().required(
                              "Promo code is required"
                            ),
                          })}
                          onSubmit={(values) => {
                            applyCouponCode(values);
                          }}
                        >
                          {({
                            handleChange,
                            handleBlur,
                            handleSubmit,
                            setFieldValue,
                            resetForm,
                            validateForm,
                          }) => (
                            <Form onSubmit={handleSubmit}>
                              <div className="pt-20 mb-10">
                                <div className="single-field relative d-flex justify-end items-center">
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: "5px",
                                      width: "100%",
                                    }}
                                  >
                                    <input
                                      name="promoCode"
                                      className="bg-white rounded-8 border-primary"
                                      type="text"
                                      placeholder="Apply Promo Code"
                                      onChange={(e) => {
                                        e.preventDefault();
                                        const { value } = e.target;

                                        // if (value.trim() === "") {
                                        //   setDiscountApplied(false);
                                        // }

                                        setFieldValue("promoCode", value);
                                      }}
                                    />
                                  </div>
                                  <LoadingButton
                                    // type="submit"
                                    loading={applyingCoupon}
                                    disabled={applyingCoupon}
                                    className="absolute px-15 py-14 text-14 fw-400 rounded-right-8"
                                    sx={{
                                      color: "#fff",
                                      bgcolor: applyingCoupon
                                        ? "#f05736 !important"
                                        : "#f05736", // Change this to your desired color
                                      color: "white", // Text color
                                      "&:hover": {
                                        bgcolor: "#f05736",
                                      },
                                    }}
                                    loadingIndicator={
                                      <span className="mui-btn-spinner"></span> // Your custom spinner
                                    }
                                    onClick={async () => {
                                      const errors = await validateForm();
                                      if (errors.promoCode) {
                                        toast.error("Please enter Coupon Code");
                                      } else {
                                        // Trigger the form submission if no errors
                                        handleSubmit();
                                      }
                                    }}
                                  >
                                    <span>Apply</span>
                                  </LoadingButton>
                                </div>
                              </div>
                              {discountApplied && validCoupon?.promoCode && (
                                <Chip
                                  label={validCoupon?.promoCode}
                                  color="success"
                                  size="small"
                                  variant="outlined"
                                  sx={{
                                    borderRadius: "6px",
                                    height: "30px",
                                    gap: "5px",
                                  }}
                                  onDelete={() => {
                                    removeCouponCode(resetForm);
                                  }}
                                />
                              )}
                              {/* <ErrorMessage
                                name="promoCode"
                                component="div"
                                className="text-error-2 text-13 mt-5"
                              /> */}
                            </Form>
                          )}
                        </Formik>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="accordion -simple row y-gap-20 js-accordion">
                  <div className="col-12">
                    <div className="accordion__item py-10 border-bottom-medium">
                      <div className="accordion__button d-flex items-center justify-between">
                        <div className="button text-primary fw-600 text-15">
                          Payment Details
                        </div>
                        {/* <div className="accordion__icon size-40 flex-center bg-white text-dark-1">
                          {!openCoupon && (
                            <i
                              className="fas fa-solid fa-chevron-down text-primary"
                              onClick={() => {
                                setOpenCoupon(true);
                              }}
                            ></i>
                          )}
                          {openCoupon && (
                            <i
                              className="fas fa-solid fa-chevron-up text-primary"
                              onClick={() => {
                                setOpenCoupon(false);
                              }}
                            ></i>
                          )}
                        </div> */}
                      </div>
                    </div>
                    <div
                      className={`d-flex mt-15 mb-15 js-lazy items-center justify-between${
                        paymentDetails?.Total_Amount_Gst > 0
                          ? ""
                          : " border-bottom-medium pb-20"
                      }`}
                    >
                      <div
                        className="text-14 lh-14 fw-500"
                        style={{ color: "#949494" }}
                      >
                        Ticket Price
                      </div>
                      <div
                        className="text-14 lh-14 fw-500"
                        style={{ color: "#949494" }}
                      >
                        ₹ {paymentDetails?.Total_Event_Price?.toFixed(2)}
                      </div>
                    </div>

                    {paymentDetails?.DiscountAmount > 0 ? (
                      <div className="d-flex mt-15 mb-15 js-lazy items-center justify-between">
                        <div
                          className="text-14 lh-14 fw-500"
                          style={{ color: "#949494" }}
                        >
                          Discount
                        </div>
                        <div
                          className="d-flex items-center"
                          style={{ gap: "8px", color: "#949494" }}
                        >
                          <div
                            className="text-14 lh-14 fw-500"
                            style={{ color: "#949494" }}
                          >
                            {discountApplied ||
                            paymentDetails?.DiscountAmount > 0
                              ? "-"
                              : ""}{" "}
                            ₹ {paymentDetails?.DiscountAmount?.toFixed(2)}
                          </div>
                        </div>
                      </div>
                    ) : (
                      <></>
                    )}

                    {paymentDetails?.Total_Amount_Gst ? (
                      <div className="d-flex mt-10 pb-20 js-lazty items-center justify-between border-bottom-medium">
                        <div
                          className="text-14 lh-14 fw-500"
                          style={{ color: "#949494" }}
                        >
                          GST @ {paymentDetails?.Gst_Per}%
                        </div>
                        <div
                          className="text-14 lh-14 fw-500"
                          style={{ color: "#949494" }}
                        >
                          {" "}
                          ₹ {paymentDetails?.Total_Amount_Gst}
                        </div>
                      </div>
                    ) : (
                      <></>
                    )}

                    <div className="d-flex mt-10 mb-15 js-lazy items-center justify-between">
                      <div className="text-14 lh-16 fw-600">TOTAL</div>

                      {isMobile ? (
                        <div className="d-flex items-center gap-5">
                          <div className="text-primary fw-600 text-32">
                            ₹{paymentDetails?.Total_To_Pay}
                          </div>
                          <ClickAwayListener onClickAway={handleClose}>
                            <div className="accordion__icon size-40 d-flex items-center justify-end bg-white text-dark-1">
                              <Tooltip
                                open={open}
                                onClose={handleClose}
                                onOpen={handleOpen}
                                disableFocusListener
                                disableHoverListener
                                // disableTouchListener
                                PopperProps={{
                                  modifiers: [
                                    {
                                      name: "arrow",
                                      enabled: true,
                                    },
                                  ],
                                }}
                                componentsProps={{
                                  tooltip: {
                                    sx: {
                                      backgroundColor: "#ffffff",
                                      color: "inherit",
                                      fontFamily: "Inter, sans-serif",
                                      boxShadow:
                                        "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                                      borderRadius: "20px",
                                      minWidth: "350px",
                                      padding: 2,
                                    },
                                  },
                                  arrow: {
                                    sx: {
                                      color: "#ffffff",
                                    },
                                  },
                                }}
                                title={
                                  <div className="accordion -simple row y-gap-20 js-accordion">
                                    <div className="col-12">
                                      <div className="accordion__item py-10 border-bottom-medium">
                                        <div className="accordion__button d-flex items-center justify-between">
                                          <div className="button text-primary fw-600 text-15">
                                            Payment Details
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        className={`d-flex mt-15 js-lazy items-center justify-between${
                                          paymentDetails?.Total_Amount_Gst > 0
                                            ? ""
                                            : " border-bottom-dotted-dark pb-15"
                                        }`}
                                      >
                                        <div
                                          className="text-14 lh-14"
                                          style={{ color: "#949494" }}
                                        >
                                          Ticket Price
                                        </div>
                                        <div
                                          className="text-14 lh-14"
                                          style={{ color: "#949494" }}
                                        >
                                          ₹{" "}
                                          {paymentDetails?.Total_Event_Price?.toFixed(
                                            2
                                          )}
                                        </div>
                                      </div>
                                      {paymentDetails?.DiscountAmount > 0 ? (
                                        <div className="d-flex mt-15 mb-15 js-lazy items-center justify-between">
                                          <div
                                            className="text-14 lh-14 fw-400"
                                            style={{ color: "#949494" }}
                                          >
                                            Discount
                                          </div>
                                          <div
                                            className="d-flex items-center"
                                            style={{
                                              gap: "8px",
                                              color: "#949494",
                                            }}
                                          >
                                            <div
                                              className="text-14 lh-14 fw-500"
                                              style={{ color: "#949494" }}
                                            >
                                              {discountApplied ||
                                              paymentDetails?.DiscountAmount > 0
                                                ? "-"
                                                : ""}{" "}
                                              ₹{" "}
                                              {paymentDetails?.DiscountAmount?.toFixed(
                                                2
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      ) : (
                                        <></>
                                      )}
                                      {paymentDetails?.Total_Amount_Gst > 0 ? (
                                        <div
                                          className={`d-flex pb-20 items-center justify-between border-bottom-dotted-dark${
                                            !paymentDetails?.DiscountAmount > 0
                                              ? " mt-15"
                                              : ""
                                          }`}
                                        >
                                          <div
                                            className="text-14 lh-14"
                                            style={{ color: "#949494" }}
                                          >
                                            GST @ {paymentDetails?.Gst_Per}%
                                          </div>
                                          <div
                                            className="text-14 lh-14"
                                            style={{ color: "#949494" }}
                                          >
                                            ₹ {paymentDetails?.Total_Amount_Gst}
                                          </div>
                                        </div>
                                      ) : (
                                        <></>
                                      )}
                                      <div className="d-flex mt-15 pb-15 js-lazy items-center justify-between border-bottom-dotted-dark">
                                        <div className="text-14 lh-16 fw-600">
                                          SUB-TOTAL
                                        </div>
                                        <div className="text-14 lh-16 fw-600">
                                          ₹{" "}
                                          {(
                                            paymentDetails?.Total_Event_Price +
                                            paymentDetails?.Total_Amount_Gst +
                                            (paymentDetails?.DiscountAmount > 0
                                              ? -paymentDetails?.DiscountAmount
                                              : paymentDetails?.DiscountAmount)
                                          )?.toFixed(2)}
                                        </div>
                                      </div>

                                      {paymentDetails?.PlatformFee_Pa_Amount >
                                      0 ? (
                                        <div
                                          className={`d-flex mt-15 mb-15 js-lazy items-center justify-between${
                                            paymentDetails?.PGCharges_Pa_Amount ===
                                              0 &&
                                            paymentDetails?.ConvenienceFee2_Pa_Amount ===
                                              0 &&
                                            paymentDetails?.ConvenienceFee1_Pa_Amount ===
                                              0
                                              ? " border-bottom-dotted-dark pb-15"
                                              : ""
                                          }`}
                                        >
                                          <div className="text-14 lh-14 fw-400">
                                            Platform Charges <br />
                                            <span className="text-10">
                                              ({paymentDetails?.PF_Per})
                                            </span>
                                          </div>
                                          <div className="text-14 lh-14 fw-400">
                                            ₹{" "}
                                            {paymentDetails?.PlatformFee_Pa_Amount.toFixed(
                                              2
                                            )}
                                          </div>
                                        </div>
                                      ) : (
                                        <></>
                                      )}

                                      {paymentDetails?.ConvenienceFee1_Pa_Amount >
                                      0 ? (
                                        <div
                                          className={`d-flex mt-15 mb-15 js-lazy items-center justify-between${
                                            paymentDetails?.PGCharges_Pa_Amount ===
                                              0 &&
                                            paymentDetails?.ConvenienceFee2_Pa_Amount ===
                                              0
                                              ? " border-bottom-dotted-dark pb-15"
                                              : ""
                                          }`}
                                        >
                                          <div className="text-14 lh-14 fw-400">
                                            Convenience Fees <br />
                                            <span className="text-10">
                                              ({paymentDetails?.Conv1_Per})
                                            </span>
                                          </div>
                                          <div className="text-14 lh-14 fw-400">
                                            ₹{" "}
                                            {paymentDetails?.ConvenienceFee1_Pa_Amount?.toFixed(
                                              2
                                            )}
                                          </div>
                                        </div>
                                      ) : (
                                        <></>
                                      )}

                                      {paymentDetails?.ConvenienceFee2_Pa_Amount >
                                      0 ? (
                                        <div
                                          className={`d-flex mt-15 mb-15 js-lazy items-center justify-between${
                                            paymentDetails?.PGCharges_Pa_Amount ===
                                            0
                                              ? " border-bottom-dotted-dark pb-15"
                                              : ""
                                          }`}
                                        >
                                          <div className="text-14 lh-14 fw-400">
                                            Convenience Fees
                                            {!paymentDetails?.ConvenienceFee2_Pa_Amount ? (
                                              <> </>
                                            ) : (
                                              <br />
                                            )}
                                            <span className="text-10">
                                              ({paymentDetails?.Conv2_Per})
                                            </span>
                                          </div>
                                          <div className="text-14 lh-14 fw-400">
                                            ₹{" "}
                                            {paymentDetails?.ConvenienceFee2_Pa_Amount?.toFixed(
                                              2
                                            )}
                                          </div>
                                        </div>
                                      ) : (
                                        <></>
                                      )}

                                      {paymentDetails?.PGCharges_Pa_Amount >
                                      0 ? (
                                        <div className="d-flex mt-15 pb-15 js-lazy items-center justify-between border-bottom-dotted-dark">
                                          <div className="text-14 lh-14 fw-400">
                                            Payment Gateway Charges <br />
                                            <span className="text-10">
                                              ({paymentDetails?.PG_Per})
                                            </span>
                                          </div>
                                          <div className="text-14 lh-14 fw-400">
                                            ₹{" "}
                                            {paymentDetails?.PGCharges_Pa_Amount?.toFixed(
                                              2
                                            )}
                                          </div>
                                        </div>
                                      ) : (
                                        <></>
                                      )}
                                      <div className="d-flex mt-10 mb-15 js-lazy items-center justify-between">
                                        <div className="text-14 lh-16 fw-600">
                                          TOTAL
                                        </div>
                                        <div className="text-14 lh-16 fw-600">
                                          ₹ {paymentDetails?.Total_To_Pay}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                }
                                placement="top"
                                arrow
                                enterTouchDelay={20}
                                leaveTouchDelay={5000}
                              >
                                <button
                                  className="fas fa-info-circle text-primary cursor-pointer text-18"
                                  onClick={handleOpen}
                                  onBlur={handleClose}
                                ></button>
                              </Tooltip>
                            </div>
                          </ClickAwayListener>
                        </div>
                      ) : (
                        <div className="d-flex items-center gap-10">
                          <div className="text-primary fw-600 text-32">
                            {/* {!paymentDetails?.Total_To_Pay
                              ? "Free"
                              : `₹ ${paymentDetails?.Total_To_Pay}`} */}
                            ₹ {paymentDetails?.Total_To_Pay}
                          </div>
                          {paymentDetails?.Total_To_Pay ? (
                            <div className="accordion__icon size-40 d-flex items-center justify-end bg-white text-dark-1">
                              <Tooltip
                                PopperProps={{
                                  modifiers: [
                                    {
                                      name: "arrow",
                                      enabled: true,
                                    },
                                  ],
                                }}
                                componentsProps={{
                                  tooltip: {
                                    sx: {
                                      backgroundColor: "#ffffff",
                                      color: "inherit",
                                      fontFamily: "Inter, sans-serif",
                                      boxShadow:
                                        "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                                      borderRadius: "20px",
                                      minWidth: "450px",
                                      padding: 2,
                                    },
                                  },
                                  arrow: {
                                    sx: {
                                      color: "#ffffff",
                                    },
                                  },
                                }}
                                title={
                                  <div className="accordion -simple row y-gap-20 js-accordion">
                                    <div className="col-12">
                                      <div className="accordion__item py-10 border-bottom-medium">
                                        <div className="accordion__button d-flex items-center justify-between">
                                          <div className="button text-primary fw-600 text-15">
                                            Payment Details
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        className={`d-flex mt-15 js-lazy items-center justify-between${
                                          paymentDetails?.Total_Amount_Gst > 0
                                            ? ""
                                            : " border-bottom-dotted-dark pb-15"
                                        }`}
                                      >
                                        <div
                                          className="text-14 lh-14"
                                          style={{ color: "#949494" }}
                                        >
                                          Ticket Price
                                        </div>
                                        <div
                                          className="text-14 lh-14"
                                          style={{ color: "#949494" }}
                                        >
                                          ₹{" "}
                                          {paymentDetails?.Total_Event_Price.toFixed(
                                            2
                                          )}
                                        </div>
                                      </div>
                                      {paymentDetails?.DiscountAmount > 0 ? (
                                        <div className="d-flex mt-15 mb-15 js-lazy items-center justify-between">
                                          <div
                                            className="text-14 lh-14 fw-400"
                                            style={{ color: "#949494" }}
                                          >
                                            Discount
                                          </div>
                                          <div
                                            className="d-flex items-center"
                                            style={{
                                              gap: "8px",
                                              color: "#949494",
                                            }}
                                          >
                                            <div
                                              className="text-14 lh-14 fw-500"
                                              style={{ color: "#949494" }}
                                            >
                                              {discountApplied ||
                                              paymentDetails?.DiscountAmount > 0
                                                ? "-"
                                                : ""}{" "}
                                              ₹{" "}
                                              {paymentDetails?.DiscountAmount?.toFixed(
                                                2
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      ) : (
                                        <></>
                                      )}
                                      {paymentDetails?.Total_Amount_Gst > 0 ? (
                                        <div
                                          className={`d-flex pb-20 items-center justify-between border-bottom-dotted-dark${
                                            !paymentDetails?.DiscountAmount > 0
                                              ? " mt-15"
                                              : ""
                                          }`}
                                        >
                                          <div
                                            className="text-14 lh-14"
                                            style={{ color: "#949494" }}
                                          >
                                            GST @ {paymentDetails?.Gst_Per}%
                                          </div>
                                          <div
                                            className="text-14 lh-14"
                                            style={{ color: "#949494" }}
                                          >
                                            ₹ {paymentDetails?.Total_Amount_Gst}
                                          </div>
                                        </div>
                                      ) : (
                                        <></>
                                      )}
                                      <div className="d-flex mt-15 pb-15 js-lazy items-center justify-between border-bottom-dotted-dark">
                                        <div className="text-14 lh-16 fw-600">
                                          SUB-TOTAL
                                        </div>
                                        <div className="text-14 lh-16 fw-600">
                                          ₹{" "}
                                          {(
                                            paymentDetails?.Total_Event_Price +
                                            paymentDetails?.Total_Amount_Gst +
                                            (paymentDetails?.DiscountAmount > 0
                                              ? -paymentDetails?.DiscountAmount
                                              : paymentDetails?.DiscountAmount)
                                          )?.toFixed(2)}
                                        </div>
                                      </div>

                                      {paymentDetails?.PlatformFee_Pa_Amount >
                                      0 ? (
                                        <div
                                          className={`d-flex mt-15 mb-15 js-lazy items-center justify-between${
                                            paymentDetails?.PGCharges_Pa_Amount ===
                                              0 &&
                                            paymentDetails?.ConvenienceFee2_Pa_Amount ===
                                              0 &&
                                            paymentDetails?.ConvenienceFee1_Pa_Amount ===
                                              0
                                              ? " border-bottom-dotted-dark pb-15"
                                              : ""
                                          }`}
                                        >
                                          <div className="text-14 lh-14 fw-400">
                                            Platform Charges <br />
                                            <span className="text-10">
                                              ({paymentDetails?.PF_Per})
                                            </span>
                                          </div>
                                          <div className="text-14 lh-14 fw-400">
                                            ₹{" "}
                                            {paymentDetails?.PlatformFee_Pa_Amount.toFixed(
                                              2
                                            )}
                                          </div>
                                        </div>
                                      ) : (
                                        <></>
                                      )}

                                      {paymentDetails?.ConvenienceFee1_Pa_Amount >
                                      0 ? (
                                        <div
                                          className={`d-flex mt-15 mb-15 js-lazy items-center justify-between${
                                            paymentDetails?.PGCharges_Pa_Amount ===
                                              0 &&
                                            paymentDetails?.ConvenienceFee2_Pa_Amount ===
                                              0
                                              ? " border-bottom-dotted-dark pb-15"
                                              : ""
                                          }`}
                                        >
                                          <div className="text-14 lh-14 fw-400">
                                            Convenience Fees <br />
                                            <span className="text-10">
                                              ({paymentDetails?.Conv1_Per})
                                            </span>
                                          </div>
                                          <div className="text-14 lh-14 fw-400">
                                            ₹{" "}
                                            {paymentDetails?.ConvenienceFee1_Pa_Amount?.toFixed(
                                              2
                                            )}
                                          </div>
                                        </div>
                                      ) : (
                                        <></>
                                      )}

                                      {paymentDetails?.ConvenienceFee2_Pa_Amount >
                                      0 ? (
                                        <div
                                          className={`d-flex mt-15 mb-15 js-lazy items-center justify-between${
                                            paymentDetails?.PGCharges_Pa_Amount ===
                                            0
                                              ? " border-bottom-dotted-dark pb-15"
                                              : ""
                                          }`}
                                        >
                                          <div className="text-14 lh-14 fw-400">
                                            Convenience Fees
                                            {!paymentDetails?.ConvenienceFee2_Pa_Amount ? (
                                              <> </>
                                            ) : (
                                              <br />
                                            )}
                                            <span className="text-10">
                                              ({paymentDetails?.Conv2_Per})
                                            </span>
                                          </div>
                                          <div className="text-14 lh-14 fw-400">
                                            ₹{" "}
                                            {paymentDetails?.ConvenienceFee2_Pa_Amount?.toFixed(
                                              2
                                            )}
                                          </div>
                                        </div>
                                      ) : (
                                        <></>
                                      )}

                                      {paymentDetails?.PGCharges_Pa_Amount >
                                      0 ? (
                                        <div className="d-flex mt-15 pb-15 js-lazy items-center justify-between border-bottom-dotted-dark">
                                          <div className="text-14 lh-14 fw-400">
                                            Payment Gateway Charges <br />
                                            <span className="text-10">
                                              ({paymentDetails?.PG_Per})
                                            </span>
                                          </div>
                                          <div className="text-14 lh-14 fw-400">
                                            ₹{" "}
                                            {paymentDetails?.PGCharges_Pa_Amount?.toFixed(
                                              2
                                            )}
                                          </div>
                                        </div>
                                      ) : (
                                        <></>
                                      )}

                                      <div className="d-flex mt-10 mb-15 js-lazy items-center justify-between">
                                        <div className="text-14 lh-16 fw-600">
                                          TOTAL
                                        </div>
                                        <div className="text-14 lh-16 fw-600">
                                          ₹ {paymentDetails?.Total_To_Pay}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                }
                                placement="right"
                                arrow
                              >
                                <i className="fas fa-info-circle text-primary cursor-pointer text-18"></i>
                              </Tooltip>
                            </div>
                          ) : (
                            <></>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="col-lg-5 col-md-6 d-flex flex-column justify-between lg:justify-end py-25"> */}
              <Formik
                initialValues={initialValues}
                validationSchema={gstAvail ? gstvalidationSchema : null}
                onSubmit={applyGst}
              >
                {({ values, setFieldValue, isValid }) => (
                  <Form className="col-lg-6 col-md-6 d-flex flex-column justify-between lg:justify-end py-5 lg:py-0">
                    <div className="d-flex flex-column gap-20 bg-blue-1-05 px-20 py-20 rounded-8">
                      <div className="d-flex gap-15">
                        <div className="form-checkbox">
                          <Field
                            disabled={!paymentDetails?.Total_To_Pay}
                            type="checkbox"
                            name="gstAvail"
                            onClick={(e) => {
                              setGstAvail(e.target.checked);
                              setIsGstFormSubmitted(false); // Reset the form submission state
                            }}
                          />
                          <div className="form-checkbox__mark">
                            <div className="form-checkbox__icon fas fa-check"></div>
                          </div>
                        </div>
                        <div className="text-14 lh-12 mr-10">
                          I have GST Details
                        </div>
                      </div>

                      {gstAvail && (
                        <>
                          <div className="single-field lg:pt-20 y-gap-20">
                            <label className="text-13 fw-500">
                              Company Name <sup className="asc">*</sup>
                            </label>
                            <div className="form-control">
                              <Field
                                type="text"
                                className="form-control"
                                name="Company_Name"
                                placeholder="Company Name"
                                maxLength="50"
                                onChange={async (e) => {
                                  const value = e.target.value;
                                  // const regex = /^[a-zA-Z][a-zA-Z\s]*$/;
                                  setIsGstFormSubmitted(false);
                                  setFieldValue("Company_Name", value);
                                  // if (!value || regex.test(value.toString())) {
                                  // } else {
                                  //   return;
                                  // }
                                }}
                              />
                            </div>
                            <ErrorMessage
                              name="Company_Name"
                              component="div"
                              className="text-error-2 text-13"
                            />
                          </div>

                          <div className="single-field lg:pt-20 y-gap-20">
                            <label className="text-13 fw-500">
                              GST Number/ GSTIN <sup className="asc">*</sup>
                            </label>
                            <div className="form-control">
                              <Field
                                type="text"
                                className="form-control"
                                name="Company_Gst"
                                placeholder="GST Number"
                                maxLength="50"
                                onChange={async (e) => {
                                  const value = e.target.value;
                                  const regex = /^\S+$/;
                                  setIsGstFormSubmitted(false);

                                  if (!value || regex.test(value.toString())) {
                                    setFieldValue("Company_Gst", value);
                                  } else {
                                    return;
                                  }
                                }}
                              />
                            </div>
                            <ErrorMessage
                              name="Company_Gst"
                              component="div"
                              className="text-error-2 text-13"
                            />
                          </div>

                          <div className="text-primary fw-600 text-18 relative pt-10">
                            <button
                              disabled={submittingGst}
                              type="submit"
                              className="button w-full h-40 w-100 px-30 text-white rounded-22 bg-primary -dark-1 load-button"
                            >
                              {!submittingGst && "Save"}
                              {submittingGst && (
                                <span className="btn-spinner"></span>
                              )}
                            </button>
                          </div>
                        </>
                      )}
                    </div>

                    <div className="text-primary fw-600 text-18 relative mt-20 d-flex justify-end">
                      <button
                        type="button"
                        disabled={
                          paying ||
                          (gstAvail && (!isValid || !isGstFormSubmitted))
                        }
                        // onClick={displayRazorpay}
                        onClick={async () => {
                          await displayRazorpay(event);
                        }}
                        className="button h-50 w-150 bg-green text-white rounded-25 px-30 py-10 -grey-1 load-button"
                      >
                        {!paying ? (
                          paymentDetails?.Total_To_Pay ? (
                            "Pay Now"
                          ) : (
                            "Proceed"
                          )
                        ) : (
                          <></>
                        )}
                        {paying && <span className="btn-spinner"></span>}
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
              {/* </div> */}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default PaymentDetails;

// useEffect(() => {
//   console.log("Refresh");

//   // Set a custom message
//   const handleBeforeUnload = (e) => {
//     const customMessage =
//       "You have unsaved changes. Are you sure you want to leave this page?";
//     e.preventDefault();
//     e.returnValue = customMessage;
//     return customMessage;
//   };
//   window.addEventListener("beforeunload", handleBeforeUnload);
//   return () => {
//     console.log("Start Again");
//     window.removeEventListener("beforeunload", handleBeforeUnload);
//   };
// }, []);
// {
/* <div className="d-flex mt-10 mb-15 js-lazy items-center justify-between">
                          <div className="text-13 lh-14 fw-500">
                            IR Charges(IR)
                          </div>
                          <div className="text-13 lh-14 fw-500">₹19</div>
                        </div>
                        <div className="d-flex mt-10 mb-15 js-lazy items-center justify-between">
                          <div className="text-13 lh-14 fw-500">
                            Payment Gateway
                          </div>
                          <div className="text-13 lh-14 fw-500">₹19.50</div>
                        </div>
                        <div className="d-flex mt-10 mb-15 js-lazy items-center justify-between">
                          <div className="text-13 lh-14 fw-500">
                            GST(IR + PG) @ 18%
                          </div>
                          <div className="text-13 lh-14 fw-500">₹7</div>
                        </div> */
// }
// {
/* <div className="border-bottom-type-1 py-35">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <h4 className="text-primary fw-600 text-16 mb-30">
                  Endurance Quest Marathon Organzes By HEO
                </h4>
                <div className="col-lg-1 col-md-6 d-flex justify-center items-center">
                  <Link
                    to="#"
                    className="button rounded-22 bg-primary px-20 py-5 text-white -dark-1"
                  >
                    Edit
                  </Link>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-2 col-md-6">
                  <div className="h-150 w-150 overflow-hidden">
                    <img
                      src={`${MEDIA_URL}/${registeredUsers[0]?.Image_Path}`}
                      className="h-full w-full rounded-100 object-cover"
                      alt="event"
                    />
                  </div>
                </div>
                <div className="col-lg-2 col-md-6 border-right">
                  <div className="text-14 text-primary lh-12">Name</div>
                  {registeredUsers?.map((user) => {
                    return (
                      <div className="text-13 lh-12 fw-600 mt-20">
                        {user?.First_Name} {user?.Last_Name}
                      </div>
                    );
                  })}
                  <div className="text-13 lh-12 fw-600 mt-20">Mike Jackson</div>
                </div>
                <div className="col-lg-2 col-md-6 border-right">
                  <div className="text-14 text-primary lh-12">Sports</div>
                  <div className="text-13 lh-12 fw-600 mt-20">Running</div>
                  {registeredUsers?.map((user) => {
                    return (
                      <div className="text-13 lh-12 fw-600 mt-20">
                        {user?.EventType_Name}
                      </div>
                    );
                  })}
                </div>
                <div className="col-lg-2 col-md-6 border-right">
                  <div className="text-14 text-primary lh-12">Category</div>
                  <div className="text-13 lh-12 fw-600 mt-20">
                    5K Climate Warriors
                  </div>
                  {registeredUsers?.map((user) => {
                    return (
                      <div className="text-13 lh-12 fw-600 mt-20">
                        {user?.EventCategory_Name}
                      </div>
                    );
                  })}
                </div>
                <div className="col-lg-3 col-md-6">
                  <div className="text-14 text-primary lh-12">Venue</div>
                  {registeredUsers?.map((user) => {
                    return (
                      <div className="text-13 lh-12 fw-600 mt-20">
                        {user?.BIB_Expo_Venue}
                      </div>
                    );
                  })}
                </div>
                <div className="col-lg-1 col-md-6 d-flex justify-center items-center">
                  <Link
                    to="#"
                    className="button rounded-22 bg-primary px-20 py-5 text-white -dark-1"
                  >
                    Edit
                  </Link>
                </div>
              </div>
            </div> */
// }
// {
/* <div className="row border-bottom-light pb-20">
                    <div className="col-lg-4 col-md-6">
                      <div className="text-13 lh-12 fw-600 mt-20">Mike Jackson</div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="text-13 lh-12 fw-600 mt-20">Running</div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="text-13 lh-12 fw-600 mt-20">
                        5K Climate Warriors
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-4 col-md-6">
                      <div className="text-13 lh-12 fw-600 mt-20">Mike Jackson</div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="text-13 lh-12 fw-600 mt-20">Running</div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="text-13 lh-12 fw-600 mt-20">
                        5K Climate Warriors
                      </div>
                    </div>
                  </div> */
// }
// {
/* <div
                          key={index}
                          // className={`row pb-20 ${
                          //   index === registeredUsers?.length - 1
                          //     ? ""
                          //     : "border-bottom-light"
                          // } `}
                          className={`row pb-25 border-bottom-dotted`}
                        > */
// }
// {
/* <div className="col-lg-4 col-md-6">
                            <div className="text-13 lh-12 fw-600 mt-20 border-right">
                              {user?.First_Name ?? ""} {user?.Last_Name ?? ""}
                            </div>
                          </div>
                          <div className="col-lg-4 col-md-6">
                            <div className="text-13 lh-12 fw-600 mt-20 border-right">
                              {user?.EventType_Name}
                            </div>
                          </div>
                          <div className="col-lg-4 col-md-6">
                            <div className="text-13 lh-12 fw-600 mt-20 border-right">
                              {user?.EventCategory_Name}
                            </div>
                          </div> */
// }
// </div>
// const CustomTextField = ({
//   field,
//   form: { setFieldValue, errors, touched },
//   ...props
// }) => {
//   const handleChange = (event) => {
//     const value = event.target.value;
//     const regex = /^[a-zA-Z0-9]*$/; // No special characters allowed
//     if (regex.test(value)) {
//       setFieldValue(field.name, value);
//     }
//   };

//   return (
//     <FormControl
//       error={touched[field.name] && !!errors[field.name]}
//       fullWidth
//     >
//       <TextField
//         className="bg-white rounded-8 border-primary"
//         {...field}
//         {...props}
//         onChange={handleChange}
//       />
//       {touched[field.name] && errors[field.name] && (
//         <FormHelperText>{errors[field.name]}</FormHelperText>
//       )}
//     </FormControl>
//   );
// };
